<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <!-- <ServerError v-if="ServerError" /> -->
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap justify-end>
          <v-flex xs12 text-right align-self-end py-2>
            <v-btn
              color="warning"
              :to="'editSeller?seller=' + $route.query.seller"
              small
              outlined
              ><span>Edit Seller</span></v-btn
            >
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center v-if="sellers.sellerid">
          <v-flex xs12 pb-lg-12 pb-5 v-if="sellers.sellerid">
            <v-img
              width="100%"
              height="300px"
              :src="mediaURL + sellers.sellerid.coverPhoto"
              class="align-center"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color=" #FDAC53"
                  ></v-progress-circular>
                </v-row>
              </template>
              <!-- <v-layout wrap>
                <v-flex xs12 text-center class="play">
                  some sample text
                </v-flex>
              </v-layout> -->
            </v-img>
          </v-flex>
          <v-flex xs12 class="headds" text-center>
            <v-layout wrap justify-start>
              <v-flex xs12 sm4 md4 lg5 align-self-start pt-lg-3 px-sm-2>
                <!-- <v-img
                  width="100%"
                  height="250px"
                  contain
                  :src="mediaURL + sellers.sellerid.photo"
                  class="align-center"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color=" #FDAC53"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img> -->
                <div v-viewer style="display: flex">
                  <img
                    style="object-fit: contain; cursor: pointer"
                    width="100%"
                    height="250px"
                    contain
                    :src="mediaURL + sellers.sellerid.photo"
                  />
                </div>
              </v-flex>
              <v-flex xs12 sm8 md8 lg7 align-self-start text-left>
                <v-layout wrap justify-start text-center>
                  <v-flex xs12 md6 lg6 align-self-start>
                    <v-layout wrap justify-start>
                      <v-flex xs12 align-self-center text-left>
                        <span class="RB medium2 borders">Shop Details</span>
                      </v-flex>
                      <v-flex xs12 py-4 align-self-center text-left>
                        <span style="font-size: 21px">
                          {{ sellers.sellerid.shopName }}</span
                        >
                      </v-flex>
                      <v-flex
                        text-left
                        align-self-center
                        v-if="sellers.sellerid.is24x7"
                        class="clr"
                        ><span style="color: green; font-size: 16px"
                          ><b> 24x7 available</b></span
                        >
                      </v-flex>
                      <v-flex md2 lg2 align-self-end text-left v-else>
                        <span style="color: red; font-size: 16px"
                          ><b>24x7 not available!</b></span
                        >
                      </v-flex>
                      <v-flex
                        xs12
                        pt-4
                        text-left
                        style="font-family: poppinsregular; font-size: 16px"
                        class="clr"
                      >
                        {{ sellers.sellerid.description }}
                      </v-flex>
                      <v-flex xs12 align-self-center text-left>
                        <span class="RR medium">City </span>
                        <span style="font-size: 18px">
                          {{ sellers.sellerid.city }}</span
                        >
                      </v-flex>
                      <v-flex xs12 align-self-center text-left>
                        <span class="RR medium">Pincode </span>
                        <span style="font-size: 18px">
                          {{ sellers.sellerid.pincode }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 md6 lg6>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        align-self-center
                        text-left
                        v-if="sellers.sellerid.socialmedialinks.hasupdated"
                      >
                        <span class="RB medium2 borders"
                          >Social Media Links</span
                        >
                      </v-flex>
                      <v-flex xs12 py-4 text-left>
                        <v-layout wrap justify-start>
                          <v-flex
                            lg2
                            sm2
                            v-if="
                              sellers.sellerid.socialmedialinks.twitter != ''
                            "
                          >
                            <a
                              target="_blank"
                              :href="sellers.sellerid.socialmedialinks.twitter"
                            >
                              <v-icon>mdi-twitter</v-icon>
                            </a>
                          </v-flex>
                          <v-flex
                            lg2
                            sm2
                            text-left
                            v-if="
                              sellers.sellerid.socialmedialinks.facebook != ''
                            "
                          >
                            <a
                              target="_blank"
                              :href="sellers.sellerid.socialmedialinks.facebook"
                            >
                              <v-icon>mdi-facebook</v-icon>
                            </a>
                          </v-flex>
                          <v-flex
                            lg2
                            sm2
                            text-left
                            v-if="
                              sellers.sellerid.socialmedialinks.whatsapp != ''
                            "
                          >
                            <a
                              target="_blank"
                              :href="
                                'https://wa.me/' +
                                sellers.sellerid.socialmedialinks.whatsapp
                              "
                            >
                              <v-icon>mdi-whatsapp</v-icon>
                            </a>
                          </v-flex>
                          <v-flex
                            lg2
                            sm2
                            text-left
                            v-if="
                              sellers.sellerid.socialmedialinks.linkedin != ''
                            "
                          >
                            <a
                              target="_blank"
                              :href="sellers.sellerid.socialmedialinks.linkedin"
                            >
                              <v-icon>mdi-linkedin</v-icon>
                            </a>
                          </v-flex>
                          <v-flex
                            lg2
                            sm2
                            text-left
                            v-if="
                              sellers.sellerid.socialmedialinks.instagram != ''
                            "
                          >
                            <a
                              :href="
                                sellers.sellerid.socialmedialinks.instagram
                              "
                            >
                              <v-icon>mdi-instagram</v-icon>
                            </a>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 text-center>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 py-3 v-if="sellers.sellerid.category">
            <v-layout wrap py-4>
              <v-flex xs12 align-self-center text-center pb-8>
                <span class="headds">Selling Category</span>
              </v-flex>
              <v-flex
                xs6
                align-self-center
                lg3
                px-2
                v-for="(items, i) in sellers.sellerid.category"
                :key="i"
              >
                <v-card
                  flat
                  elevation="2"
                  @click="
                    $router.push(
                      'filterViewProducts?category=' +
                        items._id +
                        '&seller=' +
                        $route.query.seller
                    )
                  "
                >
                  <v-layout wrap justify-start>
                    <v-flex xs12 align-self-center text-left>
                      <v-list-item-avatar>
                        <v-img contain :src="mediaURL + items.icon"></v-img>
                      </v-list-item-avatar>
                      <span style="font-family: poppinsmedium">{{
                        items.name
                      }}</span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 text-center>
            <v-divider></v-divider>
          </v-flex>

          <!-- <v-flex xs12 md12 py-16>
            <v-layout wrap px-sm-16 px-3>
              <v-flex xs12 md6 pl-md-6 lg5 pl-lg-0>
                <iframe
                  height="280"
                  :src="splitUrl"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  :style="
                    $vuetify.breakpoint.name == 'xs'
                      ? 'width:350px'
                      : 'width:450px'
                  "
                ></iframe>
              </v-flex>
              <v-flex xs12 md6 pr-md-8>
                <v-layout wrap pl-md-12>
                  <v-flex xs12 class="subhead" style="color: black" pb-3 pt-7>
                    {{ sellers.sellerProfileId.heading }}
                  </v-flex>
                  <v-flex xs12 pb-2 class="RR">
                    {{ sellers.sellerProfileId.videoDescription }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex> -->
          <!-- Strat Product  -->
          <v-flex xs12 align-self-center px-md-16 py-2 pt-8>
            <v-layout wrap justify-center>
              <v-flex xs12 text-center class="headds">Listed Products </v-flex>
              <!-- <v-flex pr-12 xs5 md5 text-right>
                <v-layout wrap text-right>
                  <v-flex class="clr RB" pt-3> FILTER</v-flex>
                  <v-flex xs2> <v-select solo flat dense></v-select></v-flex>
                </v-layout>
              </v-flex> -->
            </v-layout>
          </v-flex>
          <v-flex xs12 md12 pt-5 v-if="products && totalCount > 0">
            <v-layout wrap px-md-12 pb-3>
              <v-flex sm6 md4 v-for="(item, i) in products" :key="i" pt-lg-6>
                <v-card flat>
                  <v-layout
                    wrap
                    justify-center
                    text-center
                    px-10
                    py-6
                    v-if="item.photos"
                  >
                    <v-flex xs12 pb-2 v-if="item.photos.length > 0">
                      <v-img
                        height="250"
                        contain
                        :src="mediaURL + item.photos[0]"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color=" #FDAC53"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex xs12 pb-2 v-else>
                      <v-img
                        height="250"
                        contain
                        :src="require('./../../assets/images/no-image.png')"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color=" #FDAC53"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex style="font-family: poppinsbold" xs12>
                      {{ item.name }}
                    </v-flex>

                    <v-flex xs12 pt-1 v-if="item.discount > 0">
                      <span style="font-weight: bold">
                        Rs. {{ item.offerPrice }}
                      </span>
                      <del
                        ><span style="font-weight: bold">
                          Rs. {{ item.price }}
                        </span></del
                      >
                    </v-flex>
                    <v-flex xs12 pt-1 v-else>
                      <span style="font-weight: bold">
                        Rs. {{ item.offerPrice }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex xs12 align-self-center>
            <v-layout wrap justify-center>
              <v-flex align-self-center>
                <div class="pt-2">
                  <v-pagination
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                    :length="pages"
                    :total-visible="7"
                    v-model="currentPage"
                    color="#FDAC53"
                  ></v-pagination>
                </div>
              </v-flex>
            </v-layout>
          </v-flex> -->

          <v-flex xs12 text-center pb-8 px-2 v-if="totalCount > 0">
            <v-btn
              tile
              outlined
              :width="$vuetify.breakpoint.name == 'lg' || 'md' ? '20%' : '100%'"
              :to="'ViewProducts?seller=' + $route.query.seller"
            >
              <span class="RB">VIEW ALL PRODUCTS</span>
            </v-btn>
          </v-flex>
          <v-flex xs12 py-12 v-else>
            <span class="">No Products!!!</span>
          </v-flex>
          <!-- End Product  -->
          <v-flex xs12 md12 px-lg-5 pb-12 px-2 text-left>
            <v-card color="#FAFAFA" tile>
              <v-layout wrap px-3 py-4 pa-sm-12 justify-start>
                <v-flex xs12 md6>
                  <v-layout wrap>
                    <v-flex xs12 align-self-center>
                      <span style="font-family: poppinsbold"
                        >Shop Owner Details</span
                      >
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span><v-icon>mdi-account-outline</v-icon></span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.sellerid.contactPerson
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2>
                      <span><v-icon>mdi-phone-outline</v-icon></span>
                      <span class="RR" style="margin-left: 1%">{{
                        sellers.phone
                      }}</span>
                      <!-- <span class="RR" style="margin-left: 3%"
                        >+91 4839 333 333</span
                      > -->
                    </v-flex>
                    <v-flex xs12 py-2>
                      <span><v-icon>mdi-at</v-icon></span>
                      <span class="RR" style="margin-left: 1%">{{
                        sellers.sellerid.email
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2>
                      <span><v-icon>mdi-map-marker-outline</v-icon></span>
                      <span class="RR" style="margin-left: 1%"
                        >{{ sellers.sellerid.city }},
                        {{ sellers.sellerid.place }}</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 md6>
                  <v-layout wrap>
                    <v-flex xs12 align-self-center>
                      <span style="font-family: poppinsbold">Bank Details</span>
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span class="RR"><b> Account Holder :</b> </span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.sellerid.bankDetails.accountHolder
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span class="RR"><b> Account Number : </b> </span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.sellerid.bankDetails.accountNo
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span class="RR"><b> Bank : </b> </span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.sellerid.bankDetails.bank
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span class="RR"><b> Branch : </b></span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.sellerid.bankDetails.branch
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span class="RR"><b> IFSC :</b> </span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.sellerid.bankDetails.ifsc
                      }}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  align-self-center
                  v-if="sellers.sellerid.documents"
                >
                  <v-layout wrap justify-start>
                    <v-flex xs12 lg6 align-self-center text-left>
                      <span style="font-family: poppinsbold">Documents</span>
                    </v-flex>
                    <v-flex xs12 align-self-center text-left>
                      <v-layout wrap justify-start>
                        <v-flex
                          xs12
                          lg3
                          pa-2
                          v-for="(doc, k) in sellers.sellerid.documents"
                          :key="k"
                        >
                          <template v-if="doc.split('.').pop() !== 'pdf'">
                            <div v-viewer style="display: flex">
                              <img
                                style="object-fit: contain; cursor: pointer"
                                height="313px"
                                :src="mediaURL + doc"
                              />
                            </div>
                          </template>
                          <template v-else>
                            <a :href="mediaURL + doc" target="_blank"></a>
                          </template>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs12 md6 class="align-center RR" text-center>
                  <div>
                    No. Of <br />
                    apiaries
                  </div>
                  <div class="headds">
                    {{ sellers.sellerid.apiaryCount }}
                  </div>
                </v-flex> -->
              </v-layout>
            </v-card>
          </v-flex>
          <!-- <v-flex xs12 text-center class="headds"> Gallery </v-flex> -->
          <!-- <v-flex
            px-2
            xs12
            v-if="sellers.sellerProfileId.hiveGallery.length > 0"
            pb-12
            pt-5
          >
            <OwlCarousel :nav="true" :dots="false" :responsive="owlResponsive">
              <template
                v-for="(item, i) in sellers.sellerProfileId.hiveGallery"
              >
                <v-layout wrap :key="i">
                  <v-flex px-md-1 px-lg-3 pl-sm-2 px-xs-0>
                    <v-card tile elevation="0">
                      <v-img height="300px" cover :src="mediaURL + item">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color=" #FDAC53"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-card>
                  </v-flex>
                </v-layout>
              </template>
            </OwlCarousel>
          </v-flex> -->

          <!-- <v-flex xs12 text-center class="head">Location</v-flex>
          <v-flex xs12 py-4 align-self-center>
            <div id="mapnew5"></div>
          </v-flex> -->
          <v-divider></v-divider>
          <v-flex xs12 align-self-center v-if="sellers.status == 'Pending'">
            <v-layout wrap justify-center pa-4>
              <v-flex xs6 sm4 md3 lg2 px-2 text-left>
                <v-btn
                  width="100%"
                  small
                  color="primary"
                  @click="verifyStatus('approve')"
                  >APPROVE</v-btn
                >
              </v-flex>
              <v-flex xs6 sm4 md3 lg2 px-2 text-right>
                <v-btn
                  small
                  width="100%"
                  color="error"
                  @click="verifyStatus('reject')"
                  >REJECT</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 py-3>
        <span class="headds">Shop Location</span>
      </v-flex>
      <v-flex xs12>
        <div id="map"></div>
      </v-flex>
    </v-layout>

    <!-- verify  -->

    <v-dialog persistent v-model="verifyDelete" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="#ffffff" v-on="on" v-bind="attrs">mdi-delete</v-icon>
      </template>
      <v-card>
        <v-card-title>{{ notice }}</v-card-title>
        <v-card-title>
          <v-layout wrap v-if="isReject">
            <v-flex xs12 pa-4>
              <v-form v-model="validates" ref="form">
                <v-textarea
                  outlined
                  color="warning"
                  name="input-7-4"
                  v-model="reason"
                  :rules="[req.required]"
                  label="Enter the remarks"
                ></v-textarea>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="(verifyDelete = false), (isReject = false), (reason = '')"
            >Cancel</v-btn
          >
          <v-btn
            :disabled="!validates && isReject"
            color="primary"
            text
            @click="updateStatus(keepStatus)"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- verify  -->

    <!-- <v-dialog v-model="verifyDelete" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="#ffffff" v-on="on" v-bind="attrs">mdi-delete</v-icon>
      </template>
      <v-card>
        <v-card-title>{{ notice }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="verifyDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" text @click="updateStatus(keepStatus)"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>


<script
 src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&callback=initMap&libraries=&v=weekly"
      async>
</script>
<script>
// import ImageLoader from "@/components/Common/imageLoader";
import axios from "axios";
export default {
  data() {
    return {
      currentPage: 1,
      sellers: [],
      products: [],
      totalCount: 0,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      splitUrl: "",
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 3, nav: false },
        960: { items: 3, nav: false },
        1264: { items: 4, nav: false },
      },
      mapData: [],
      latt: null,
      lonn: null,
      map3: null,
      marker: [],
      verifyDelete: false,
      keepStatus: "",
      notice: "",
      isReject: false,
      validates: false,
      reason: "",
      req: {
        required: (value) => !!value || "Required.",
      },
      marker: [],
      msg: "",
      latt: 0,
      lonn: 0,
      maps: null,
      flag: false,
    };
  },
  components: {
    // ImageLoader,
  },
  watch: {
    currentPage() {
      // this.getData();
      this.getProduct();
    },
  },
  beforeMount() {
    if (this.$route.query.seller) {
      this.getData();
      this.getProduct();
    }
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      this.map3 = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 22.5937, lng: 78.96 },
        zoom: 9,
        mapTypeId: google.maps.MapTypeId.HYBRID,
      });
    },
    mark(event) {
      console.log("eve", event);
      this.latt = null;
      this.lonn = null;
      this.marker.setMap(null);
      this.latt = event.latLng.lat();
      this.lonn = event.latLng.lng();
      console.log("mark lt is", this.latt);
      console.log("mark ln is", this.lonn);

      this.marker = new google.maps.Marker({
        position: { lat: this.latt, lng: this.lonn },
        map: this.maps,
        title: "Hello World!",
      });
      console.log("marker =", this.latt);
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/view/" + this.$route.query.seller,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.sellers = response.data.data;
            this.latt = this.sellers.sellerid.location[1];
            this.lonn = this.sellers.sellerid.location[0];
            // console.log(this.lonn);
            this.map3 = new google.maps.Map(document.getElementById("map"), {
              center: { lat: this.latt, lng: this.lonn },
              zoom: 18,
              mapTypeId: google.maps.MapTypeId.HYBRID,
              // tilt: 170
            });

            this.marker = new google.maps.Marker({
              position: { lat: this.latt, lng: this.lonn },
              map: this.map3,
            });
            this.pages = response.data.pages;
            // this.excel = response.data.data;

            // this.json_data = this.excel;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          userid: this.$route.query.seller,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.products = response.data.data;
            this.totalCount = response.data.totalLength;
            // this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    verifyStatus(status) {
      this.verifyDelete = true;
      this.keepStatus = status;
      if (status == "approve")
        this.notice = "Do you want to approve this request?";
      else if (status == "reject") {
        this.isReject = true;
        this.notice = "Do you want to reject this request?";
      }
    },
    updateStatus(status) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/approve/reject",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.seller,
          action: status,
          remark: this.reason,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.getData();
            this.verifyDelete = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    cutVideo(eve) {
      let b = "https://www.youtube.com/embed/";
      // this.programs.video[0]
      // this.splitUrl(eve.replace("https://youtu.be/", embed));
      var em = eve.replace("https://youtu.be/", b);
      this.splitUrl = em;
      // console.log(this.splitUrl);
    },
  },
};
</script>

<style  scoped>
#map {
  height: 400px;
  /* The height is 400 pixels */
  width: 100%;
  /* The width is the width of the web page */
}
</style>